import AxiosService from '@/api/ApiBase';
import { FilterOptionsParams, FiltersService } from '@/types/service/filters.service';
import { MblEntity } from '@/types/mbl/mbl.entity';
import { MblFilters } from '@/types/mbl/mbl.filters';
import { PttApplication } from '@/composables/usePttApplication';
import { RestoreService } from '@/types/service/restore.service';
import { VirtualSearchPayload, VirtualSearchResponse } from '@/types/virtual-search';
const MASTER_BASE_URL = 'warehouse/manifest/mbl';

// const MASTER_BASE_URL = 'http://localhost:3000/api/manifest/mbl';

export interface CloseMblResponse {
  closeStatus: boolean;
  haveHbls?: boolean;
  allHaveReleased?: boolean;

  allAreInActiveLoadGuide?: boolean;
  haveIpiItems?: boolean;
  allHaveActualPickedUpdate?: boolean;
  allIpiInTransit?: boolean;
  haveNonIpiItems?: boolean;
  mblChargesPaid?: boolean;
  allHaveInTransit?: boolean;
}

export interface MblFinalizingValidationResponse {
  status: boolean;
  mblNumber: boolean;
  containerNumber: boolean;
  customer: boolean;
  stripDate: boolean;
  closedate: boolean;
  hbls: boolean;
}

class MasterService implements FiltersService<MblEntity, MblFilters>, RestoreService {
  getAll() {
    return AxiosService.get(`${MASTER_BASE_URL}/all`);
  }

  virtualSearch(payload: VirtualSearchPayload<MblEntity>) {
    return AxiosService.post<VirtualSearchResponse<MblEntity>>(
      'warehouse/v2/manifest/mbl/search',
      payload
    );
  }

  restore(id: string) {
    return AxiosService.put<string>(`${MASTER_BASE_URL}/restore/${id}`);
  }

  get(id: string) {
    return AxiosService.get(`${MASTER_BASE_URL}/${id}`);
  }

  update(data: any) {
    return AxiosService.put(`${MASTER_BASE_URL}/update`, data);
  }

  close(mblId: string) {
    return AxiosService.put<MblEntity>(`${MASTER_BASE_URL}/close/${mblId}`);
  }

  create(data: any) {
    return AxiosService.post(`${MASTER_BASE_URL}/create`, data);
  }

  delete(id: string) {
    return AxiosService.delete(`${MASTER_BASE_URL}/delete/${id}`);
  }

  getMilestones(id: string) {
    return AxiosService.get(`${MASTER_BASE_URL}/get/milestones/${id}`);
  }

  getAmsPttDetailsById(id: string) {
    return AxiosService.get<PttApplication>(`warehouse/ptt/request-details/${id}`);
  }

  checkContainerDuplicate(id: string) {
    return AxiosService.get(`${MASTER_BASE_URL}/checkContainerNumber`, {
      params: {
        containerNumber: id,
      },
    });
  }

  validateContainerStatus(mblNumber: string, containerNumber: string, mblId?: string) {
    return AxiosService.get<{ status: boolean }>(`${MASTER_BASE_URL}/validate/containerStatus`, {
      params: {
        mblNumber: mblNumber,
        containerNumber: containerNumber,
        mblId: mblId,
      },
    });
  }

  validateCloseStatus(id: string) {
    return AxiosService.get<CloseMblResponse>(`${MASTER_BASE_URL}/validate/closeStatus`, {
      params: {
        manifestId: id,
      },
    });
  }

  getFilteredItems(filters: MblFilters) {
    return AxiosService.post(`${MASTER_BASE_URL}/get/filter`, filters);
  }

  getFilterOptions<T>(params: Omit<FilterOptionsParams, 'limit'>) {
    return AxiosService.get<T>(`${MASTER_BASE_URL}/filter/options`, {
      params: {
        ...params,
        limit: 100,
      },
    });
  }

  validateForFinalize(mblId: string) {
    return AxiosService.get<MblFinalizingValidationResponse>(
      `${MASTER_BASE_URL}/finalize/validate`,
      { params: { mblId } }
    );
  }

  finalize(mblId: string) {
    return AxiosService.put(`${MASTER_BASE_URL}/finalize`, { mblId });
  }

  getVesselDetails(warehouse: string) {
    return AxiosService.get(`/reference/econdb?path=maritime/ports/async/${warehouse}`);
  }
}

export default new MasterService();
